import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import OfflineBanner from '../../assets/offline-banner'
import Button from '../Button/Button'
import './InternetIssue.css'
import CONFIG from '../../config'

const InternetIssue = (props) => {
    const { t } = useTranslation()

    useEffect(() => {
        let el = document.getElementById('II')
        el.scrollIntoView()
    }, [])

    const buttonClickHandler = () => {
        if (props.showLoginButton) {
            window.location.replace(CONFIG.antheDashboardLoginUrl)
        } else {
            if (props.eventType === 'logout') {
                window.location.href = props.baseUrl
            } else window.location.reload()
        }
    }

    return (
        <div className="mainContainer">
            <div className="offline" id="II">
                <div className="banner-wrapper">
                    <OfflineBanner />
                </div>
                <section role="section" className="offline-footer">
                    <span className="offline-footer-title">{t('Whoops!')}</span>
                    <span className="offline-footer-text">{props.message}</span>
                    <Button
                        name={props.showLoginButton ? 'Login' : 'Try Again'}
                        onClick={buttonClickHandler}
                        classes="btn_class"
                    />
                </section>
            </div>
        </div>
    )
}

export default React.memo(InternetIssue)
